import styled from 'styled-components';

export const FullPanel = styled.div`
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  flex: 1;
  height: 100%;
  overflow-y: auto;
`;

export const SubPanel = styled.div`
  display: flex;
  flex-direction: column;
  padding: 6px 15px;
`;

export const SubPanelHeader = styled.div`
  width: 100%;
  display: flex;
  align-self: ${({ alignSelf }) => alignSelf || 'center'};
`;

export const SubPanelRow = styled.div`
  display: flex;
  width: 100%;
  padding: 6px 0;
`;

export const PanelRowDescriptor = styled.div`
  min-width: 140px;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  align-self: ${({ alignSelf }) => alignSelf || 'center'};
`;

export const PanelRowModeDescriptor = styled.div`
  min-width: 140px;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  align-self: ${({ alignSelf }) => alignSelf || 'center'};
  padding-left: 16px;
`;

export const PanelRowDisplay = styled.div`
  width: 100%;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  align-self: ${({ alignSelf }) => alignSelf || 'center'};
  word-break: break-word;
`;

export const PanelRowTextForm = styled.input`
  min-width: 0;
  width: 100%;
  height: 24px;
  padding: 2px;
  font-size: 16px;
  box-sizing: border-box;
  border-radius: 2px;
  border: 1px solid #d8d8d8;

  :disabled {
    background: #ededed;

    :hover {
      cursor: not-allowed;
    }
  }
`;

export const TableIcon = styled.img`
  vertical-align: middle;
  padding: 0 4px;
`;

export const CoordinateInputContainer = styled.div`
  display: flex;
  width: 175px;
  font-size: 12px;
`;

export const PanelButtonRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px 3px;
  box-shadow: ${({ noBorder }) =>
    noBorder ? 'none' : '0 0 6px 3px rgba(0, 0, 0, 0.12)'};
  z-index: 1;
`;

export const StyledForm = styled.form`
  height: 100%;
`;

export const PanelContent = styled.div`
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: auto;
  height: 100%;
`;

// Curve Related
export const CurveTableCoordinatesContainer = styled.div`
  display: flex;
  margin-bottom: 10px;
`;

export const CurveTableCoordinate = styled.div`
  min-width: 50px;
`;

export const CurvePanelGraphContainer = styled.div`
  max-width: 450px;
  width: 100%;
  padding-left: 15px;
`;

export const CurveThumbnailContainer = styled.div`
  height: 40px;
  width: 40px;
  background: #ffffff;
  margin: 0 auto;
`;

// Styled input fields

// Use TwoInputRowContainer to wrap 2 `InputAndLabelContainer` when having them share a row
// Note: Add width of `47%` prop to `InputAndLabelContainer`
export const MultipleInputRowContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

export const LabledInput = styled.input`
  width: 60%;
  height: 100%;
  box-sizing: border-box;
  border-radius: 2px 0 0 2px;
  padding: 0;
  border: ${({ isError }) =>
    isError ? '1.5px solid #EA6E6D' : '1px solid #d8d8d8'};

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  -moz-appearance: textfield;

  :disabled {
    background: #ededed;

    :hover {
      cursor: not-allowed;
    }
  }
`;

export const DurationInput = styled.input`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border-radius: 2px 0 0 2px;
  padding: 0;
  border: ${({ isError }) =>
    isError ? '1px solid #EA6E6D' : '1px solid #d8d8d8'};

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  -moz-appearance: textfield;
`;

export const InputUnitLabel = styled.div`
  width: 28px;
  font-size: 12px;
  background-color: #014c6b;
  border-radius: 0 2px 2px 0;
  color: white;
  text-align: center;
  vertical-align: center;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const InputAndLabelContainer = styled.div`
  font-family: Crossten;
  display: flex;
  height: 24px;
  width: ${({ width }) => width || '100%'};
  box-sizing: border-box;
`;

export const Dropdown = styled.select`
  border: ${({ hasError }) =>
    hasError ? '1px solid #EA6E6D' : '1px solid #E5E7EB'};
  background-color: #ffffff;
  border-radius: 2px;
  width: 100%;
  height: 26px;
  font-size: 12px;
`;

export const DatePickerWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  height: 24px;
  .react-datepicker__triangle {
    display: none;
  }
  .react-datepicker-wrapper,
  .react-datepicker__input-container {
    display: block;
    width: 100%;

    input {
      width: 100%;
      box-sizing: border-box;
      height: 24px;
    }
  }
  .react-datepicker__input-container {
    width: 100%;
  }
`;

export const RadioButtons = styled.div`
  display: flex;
  width: 100%;
`;

export const RadioOption = styled.div`
  padding-right: 24px;
  font-size: 12px;
`;

export const RadioInput = styled.input`
  padding: 8px;
`;
